module.exports = __webpack_public_path__ + "img/guanyu_js.2d1a37e1.png";